import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ServiceRepository } from '../service-repository';
import {uploadDetails} from '../../Model/Docketupload/DocketUpload';


@Injectable({
  providedIn: 'root'
})
export class DocketUploadServiceService {

  constructor(
    private httpClient: HttpClient,
    private _servicerepository: ServiceRepository
  ) { }

  uploadSingleFile(file: File, userId: string,  AppType:string): Observable<HttpEvent<{}>> {
    const formData: FormData = new FormData();
    formData.append('files', file);
    formData.append('userName', userId);  
    formData.append('AppType', AppType);
   
   console.log(formData)
    return this._servicerepository.upload('/api/upload/uploadfile/', formData)
  }
}
